import React, { useEffect } from "react";
import Chart from "react-apexcharts";
import { useCurrencyStore } from "../../store/currencyStore";

const CurrencyTrendChart: React.FC = () => {
  const { currencies, fetchCurrencies } = useCurrencyStore();

  useEffect(() => {
    if (currencies.length === 0) {
      fetchCurrencies();
    }
  }, [currencies.length, fetchCurrencies]);

  // X-axis = currency codes, Y-axis = rates
  const codes = currencies.map((c) => c.currency);
  const rates = currencies.map((c) => c.rate);

  const options: ApexCharts.ApexOptions = {
    chart: {
      height: 350,
      type: "area",
      toolbar: { show: false },
    },
    colors: ["#38bdf8"],
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    xaxis: {
      categories: codes,
      labels: { style: { colors: "#ffffff" } },
    },
    yaxis: {
      title: {
        text: "Exchange Rate (MWK)",
        style: { color: "#ffffff" },
      },
      labels: { style: { colors: "#ffffff" } },
    },
    tooltip: {
      y: {
        formatter: (val) => `MWK ${val.toLocaleString()}`,
      },
    },
  };

  const series = [
    {
      name: "Exchange Rate",
      data: rates,
    },
  ];

  return (
    <div className="bg-card p-4 rounded-lg shadow">
      <div className="flex items-center justify-between">
        <h2 className="text-md text-white font-semibold mb-4">
          Currency Exchange Rates
        </h2>
        <h2 className="text-md text-white font-semibold mb-4">
          {new Date().toLocaleDateString()}
        </h2>
      </div>
      <Chart options={options} series={series} type="area" height={350} />
    </div>
  );
};

export default CurrencyTrendChart;
